import { createSelector } from 'reselect'
import type { StateWithCarouselViewer } from './reducer'

// Selectors that only access the relevant substate (carouselViewerState)
const getCarouselViewerState = (state: StateWithCarouselViewer) =>
    state.carouselViewer

export const getCurrentViewInfo = createSelector(
    getCarouselViewerState,
    (carouselViewerState) => carouselViewerState.currentView,
)
export const getPreviousViewInfo = createSelector(
    getCarouselViewerState,
    (carouselViewerState) => carouselViewerState.prevView,
)

export const isSideModuleExpanded = createSelector(
    getCarouselViewerState,
    (carouselViewerState) =>
        carouselViewerState.currentSideModule !== undefined,
)
export const getCurrentSideModuleContent = createSelector(
    getCarouselViewerState,
    (carouselViewerState) => carouselViewerState.currentSideModule,
)
export const isFullscreenMode = createSelector(
    getCarouselViewerState,
    (carouselViewerState) => carouselViewerState.isInFullscreenMode,
)

export const isCarouselCasting = createSelector(
    getCarouselViewerState,
    (carouselViewerState) => carouselViewerState.castingDetail !== undefined,
)
export const getCastDetails = createSelector(
    getCarouselViewerState,
    (carouselViewerState) => carouselViewerState.castingDetail,
)

export const isCarouselAutoplaying = createSelector(
    getCarouselViewerState,
    (carouselViewerState) => carouselViewerState.shouldAutoNavigate,
)
export const getVideoPlayStatus = createSelector(
    getCarouselViewerState,
    (carouselViewerState) => carouselViewerState.videoPlayStatus,
)
